import React from 'react';
import { Box, Button, Container, Grid, Typography } from '@mui/material';
import FeatureCards from './FeatureCards';
import { useState } from 'react';
import DemoFormModal from './DemoFormModal';

const FeaturesSection = () => {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  
  const handleOpenDemoModal = () => setIsDemoModalOpen(true);
  const handleCloseDemoModal = () => setIsDemoModalOpen(false);

  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        px: { xs: 2, md: 4 },
        // bgcolor: '#FFFFFF',
        position: 'relative',
        overflow: 'hidden',
        borderRadius: 4,
        maxWidth: 1200,
        px: { xs: 2, md: 4 },
        mx:"auto"
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            textAlign: 'center',
            mb: { xs: 6, md: 8 },
          }}
        >
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontSize: { xs: '32px', md: '48px' },
              fontWeight: 600,
              mb: 2,
              lineHeight: 1.2,
              letterSpacing:-1.8,
              color:"#4728c4"
            }}
          >
            Powerful tools for comprehensive analysis
       
          </Typography>
        </Box>

        <Box
          // sx={{
          //   position: 'relative',
          //   '&::before': {
          //     content: '""',
          //     position: 'absolute',
          //     top: -100,
          //     left: -200,
          //     width: 400,
          //     height: 400,
          //     background: '#E6E0FF',
          //     borderRadius: '50%',
          //     filter: 'blur(100px)',
          //     opacity: 0.5,
          //     zIndex: 0,
          //   },
          //   '&::after': {
          //     content: '""',
          //     position: 'absolute',
          //     bottom: -100,
          //     right: -200,
          //     width: 400,
          //     height: 400,
          //     background: '#E6E0FF',
          //     borderRadius: '50%',
          //     filter: 'blur(100px)',
          //     opacity: 0.5,
          //     zIndex: 0,
          //   },
          // }}
        >
          <FeatureCards />

          <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        pt:2,
       
      }}>
                 <Button
              variant="contained"
              onClick={handleOpenDemoModal}
              sx={{ 
                bgcolor: 'white',
                color: '#4728c4',
                px: 4,
                py: 1.75,
                borderRadius: 12,
                fontSize: '16px',
                fontWeight: 600,
                '&:hover': {
                  bgcolor: '#3B20A3',
                  color: 'white',
                  transform: 'translateY(-2px)',
                },
                transition: 'all 0.2s ease-in-out',
                borderRadius: '12px',
                textTransform: 'none',
              }}
            >
              Explore more features
            </Button>
      </Box>
              <DemoFormModal open={isDemoModalOpen} onClose={handleCloseDemoModal} />
        </Box>
      </Container>
    </Box>
  );
};

export default FeaturesSection; 